require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/legacy/floors/header/main-header-sticky.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/legacy/floors/header/main-header-sticky.legacy.js
// module id = 694
// module chunks = 31